const types = {
  GET_FAQ_BY_PAGE_START: 'GET_FAQ_BY_PAGE_START',
  GET_FAQ_BY_PAGE_SUCCESS: 'GET_FAQ_BY_PAGE_SUCCESS',
  GET_FAQ_BY_PAGE_FAILURE: 'GET_FAQ_BY_PAGE_FAILURE',
  GET_FAQ_TEMPLATES_START: 'GET_FAQ_TEMPLATES_START',
  GET_FAQ_TEMPLATES_SUCCESS: 'GET_FAQ_TEMPLATES_SUCCESS',
  GET_FAQ_TEMPLATES_FAILURE: 'GET_FAQ_TEMPLATES_FAILURE',
};
export default types;
